module.exports = __webpack_public_path__ + "img/3d0ea1f.png";